import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import { Link, useNavigate } from 'react-router-dom';
//import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isWaiting, setIsWaiting] = useState(false);
  //const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setIsWaiting(() => true);

    try {
      await signInWithEmailAndPassword(auth, email, password);

      setTimeout(() => {
        setIsWaiting(() => false);
        navigate('/dashboard');
      }, 3000);
    } catch (err) {
      setIsWaiting(() => false);
      setError('Email o password non corretti.');
    }
  };

  return (
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
          Accedi al tuo account
        </h2>
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        {error && <p className="mb-3 text-sm text-red-500">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={e => setEmail(() => e.target.value)}
                required
                autoComplete="email"
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
              />
            </div>
          </div>
          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                Password
              </label>
            </div>
            <div className="mt-2">
              <input
                id="password"
                name="password"
                //type={showPassword ? 'text' : 'password'}
                type="password"
                value={password}
                onChange={e => setPassword(() => e.target.value)}
                required
                autoComplete="current-password"
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
              />
            </div>
          </div>
          <div>
            <button
              type="submit"
              className={`flex w-full items-center justify-center gap-2 rounded py-2 text-white 
                        ${isWaiting ? 'cursor-not-allowed bg-primary' : 'bg-primary hover:bg-primary'}`}
            >
              {isWaiting ? (
                <>
                  <svg
                    className="size-5 animate-spin text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                    />
                  </svg>
                  Accesso in corso...
                </>
              ) : (
                'Accedi'
              )}
            </button>
          </div>
        </form>

        {/* Link per registrarsi */}
        <p className="mt-10 text-center text-sm/6 text-gray-500">
          Non hai un account?{' '}
          <Link to="/signup" className="font-semibold text-primary hover:text-primary">
            Registrati
          </Link>
        </p>

        {/* Link per recupero password */}
        <p className="mt-2 text-center text-sm text-gray-600">
          Password dimenticata?{' '}
          <Link to="/forgot-password" className="font-semibold text-primary hover:text-primary">
            Recupera l&apos;accesso
          </Link>
        </p>
      </div>
    </div>
  );
}
